import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../Button';
import { ISelect } from '../../../models/common.model';
import { Select } from 'antd';
import { ISubcode } from '../../../models/codes.model';
import i18n from '../../../lib/i18n';
const { Option } = Select;

interface IProps {
  year: string;
  setYear: (year: any) => void;
  yearList: ISelect[];
  name: string;
  setName: (name: string) => void;
  onSearch: () => void;
  semesterType?: string;
  setSemesterType?: (semesterType: string) => void;
  semesterTypeList?: ISubcode[] | undefined;
}

const SemesterSearch: FC<IProps> = ({
  year,
  setYear,
  yearList,
  name,
  setName,
  onSearch,
  semesterType,
  setSemesterType,
  semesterTypeList
}) => {
  const { t } = useTranslation();
  return (
    <>
    <div className="common-search">
      <div className="search-area">
        <ul className="search-bx">
          <li>
          <label>{t('common.semester.type')}</label>
            <Select
              value={semesterType}
              onChange={(value)=>{
                if(setSemesterType) {
                  setSemesterType(value);
                }
              }}
            >
              <Select.Option value="">
                {t('common.text.all')}
              </Select.Option>
              {
                semesterTypeList?.map((item) => {
                  return (
                    <Select.Option
                        key={item.detailCode}
                        value={item.detailCode}
                    >
                        {i18n.language === 'ko' ? item.korName : item.engName}
                    </Select.Option>
                  );
                })
              }
            </Select>
          </li>
          <li>            
            <label>{t('program.semester.column9')}</label>
            <Select
              value={year}
              onChange={value => setYear(value)}
            >
              {
                yearList?.map((item: any) => {
                  return (
                    <Option
                      key={item.value}
                      value={item.value}
                    >
                      {item.label}
                    </Option>
                  )
                })
              }
            </Select>
          </li>
          <li>
            <input
              type="text"
              className="form-control"
              placeholder={t('program.semester.placeholder3')}
              value={name}
              onChange={(e => setName(e.target.value))}
              onKeyPress={e => { if (e.key === 'Enter') onSearch() }}
            />
            <div className="comm-btn__area">
              <Button
                className='btn-basic small black'
                onClick={onSearch}
                text={t('common.button.search')}
              />
            </div>
          </li>
        </ul>
      </div>
    </div>
    </>
  );
}

export default SemesterSearch;
